

// import {ICustomHoliday,CCustomHoliday} from './custom-holiday';

export interface IWorkstyle {
  workstyleID: number;
  name: string;
  startTime: string;
  endTime: string;
  restTime: string;
  holiday: string[];
  cutoffDay: number;
  weekFirst: number;
  yearFirst: string;
  legalHoliday: number;
}

export class CWorkstyle implements IWorkstyle {
  public workstyleID = 0;
  public name = '';
  public startTime = '10:00';
  public endTime = '19:00';
  public restTime = '01:00';
  public holiday = ['土', '日', '祝日'];
  public cutoffDay = 99;
  public weekFirst = 0;
  public yearFirst = '';
  public legalHoliday = 1;
}
